import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
export var CLASS_STUDENT_PROGRESS_API = 'CLASS_STUDENT_PROGRESS_API';
export var ClassStudentProgressApi = /*#__PURE__*/function () {
  function ClassStudentProgressApi(classClient, assignmentClient) {
    _classCallCheck(this, ClassStudentProgressApi);

    this.classClient = classClient;
    this.assignmentClient = assignmentClient;
  }

  _createClass(ClassStudentProgressApi, [{
    key: "path",
    value: function path(input) {
      return "classes/".concat(encodeURIComponent(input.classId), "/students/").concat(encodeURIComponent(input.studentId));
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, path, params) {
        var response, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return client.get(path, {
                  params: params
                });

              case 3:
                response = _context.sent;
                body = response.data;
                return _context.abrupt("return", body.data ? Result.ok(body.data) : Result.fail(body.message));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      function get(_x, _x2, _x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getTeacherOverview",
    value: function getTeacherOverview(classId) {
      return this.get(this.assignmentClient, "classes/".concat(encodeURIComponent(classId), "/overview"));
    }
  }, {
    key: "listSubmissions",
    value: function listSubmissions(input) {
      var _input$limit;

      return this.get(this.assignmentClient, "".concat(this.path(input), "/assignments/").concat(encodeURIComponent(input.assignmentId), "/submissions"), {
        limit: (_input$limit = input.limit) !== null && _input$limit !== void 0 ? _input$limit : 20,
        nextToken: input.nextToken
      });
    }
  }, {
    key: "getStudent",
    value: function getStudent(input) {
      return this.get(this.classClient, this.path(input));
    }
  }, {
    key: "getOverview",
    value: function getOverview(input) {
      return this.get(this.assignmentClient, "".concat(this.path(input), "/overview"));
    }
  }, {
    key: "listAssignments",
    value: function listAssignments(input) {
      return this.get(this.assignmentClient, "".concat(this.path(input), "/assignments"), input.filters);
    }
  }]);

  return ClassStudentProgressApi;
}();